import { render, staticRenderFns } from "./ElevenLabsVoiceSelect.vue?vue&type=template&id=789b7dbe&scoped=true"
import script from "./ElevenLabsVoiceSelect.vue?vue&type=script&lang=js"
export * from "./ElevenLabsVoiceSelect.vue?vue&type=script&lang=js"
import style0 from "./ElevenLabsVoiceSelect.vue?vue&type=style&index=0&id=789b7dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b7dbe",
  null
  
)

export default component.exports